import { useEffect, useState } from "react";
import { fetchChannelSharedItems, type ChannelSharedItem } from "../../../lib/libraries";
import { getAuthToken } from "../../../lib/auth";

// Module-level copy of the channel-key helper (the useFavorites/fq precedent).
const fq = (vId: string, cId: string) => (cId.includes(':') ? cId : `${vId}:${cId}`);

/**
 * Per-channel shared-library items (step 6.3b).
 *
 * Owns the `sharedItemsByChannel` cache and the effect that loads the current
 * channel's shared items whenever the active conversation changes. The derived
 * `currentSharedItems` (read by the shared-items strip + library panel JSX) stays
 * in the composition layer reading the returned map, since it depends on the
 * parent-derived `currentChannelFqid`.
 */
export function useSharedItems(currentVoidId: string, currentChannelId: string) {
  const [sharedItemsByChannel, setSharedItemsByChannel] = useState<Record<string, ChannelSharedItem[]>>({});

  useEffect(() => {
    if (!currentVoidId || !currentChannelId) return;
    const fid = fq(currentVoidId, currentChannelId);
    let cancelled = false;
    (async () => {
      try {
        const tok = getAuthToken() || '';
        if (!tok) return;
        const items = await fetchChannelSharedItems(tok, fid);
        if (!cancelled) {
          setSharedItemsByChannel(prev => ({ ...prev, [fid]: items }));
        }
      } catch { /* noop */ }
    })();
    return () => { cancelled = true; };
  }, [currentVoidId, currentChannelId]);

  return { sharedItemsByChannel };
}
